import { peekClaimBreweryHandoff } from './claimBreweryHandoff';

/**
 * Default landing path for a signed-in user who has completed email verification.
 * A brewery id handed off from the app claim link sends every verified user to
 * the claim form, including brewery admins and global admins.
 * @param {null | undefined | { isGlobalAdmin?: boolean, isBreweryAdmin?: boolean }} [sessionUser]
 * @returns {string}
 */
export function getVerifiedUserDestination(sessionUser) {
  if (peekClaimBreweryHandoff().length > 0) {
    return '/brewery-portal/claim';
  }
  const user = sessionUser ?? {};
  if (user.isGlobalAdmin === true) {
    return '/dashboard';
  }
  if (user.isBreweryAdmin === true) {
    return '/brewery-portal/dashboard';
  }
  return '/brewery-portal/claim';
}
